// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a93216 {
  background-color: var(--base-background-overlay);
  height: 100vh;
  left: 0;
  opacity: 0;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  transition: opacity 300ms ease;
  width: 100vw;
  z-index: 1010;
}
.b62fc7 {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/helpers/Overlay/Overlay.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,aAAa;EACb,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;AACZ","sourcesContent":[".a93216 {\n  background-color: var(--base-background-overlay);\n  height: 100vh;\n  left: 0;\n  opacity: 0;\n  overflow-y: scroll;\n  position: fixed;\n  top: 0;\n  transition: opacity 300ms ease;\n  width: 100vw;\n  z-index: 1010;\n}\n.b62fc7 {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
